/**
 * Keeps the free-gift line items in sync with their paired main product.
 * If a main product (Diabetes Daily Log Book / Kidney Friendly) is removed
 * from the cart, its associated free-gift variants are removed too.
 *
 * Reacts to Dawn's `cart-update` pub/sub event (fired after any AJAX cart
 * mutation, drawer or full cart page) rather than to specific click targets,
 * so it works regardless of which UI control triggered the removal.
 */
(function () {
  var GIFT_MAP = {
    '53622493184309': [53622628155701, 53622629761333, 53622629695797], // Diabetes Daily Log Book
    '53622489579829': [53622629597493, 53622629564725, 53622628254005], // Kidney Friendly (50% OFF)
    '53622500032821': [53622628024629, 53622627926325, 53622627893557]  // The 5-Sheet Diabetes Meal Plan Set
  };

  function applySections(state) {
    if (!state || !state.sections) return;

    var drawerHtml = state.sections['cart-drawer'];
    if (drawerHtml) {
      var drawerTarget = document.getElementById('CartDrawer');
      if (drawerTarget) {
        var drawerSource = new DOMParser().parseFromString(drawerHtml, 'text/html').querySelector('#CartDrawer');
        if (drawerSource) drawerTarget.innerHTML = drawerSource.innerHTML;
      }
    }

    var bubbleHtml = state.sections['cart-icon-bubble'];
    if (bubbleHtml) {
      var bubbleTarget = document.getElementById('cart-icon-bubble');
      if (bubbleTarget) {
        var bubbleSource = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
        if (bubbleSource) bubbleTarget.innerHTML = bubbleSource.innerHTML;
      }
    }

    ['main-cart-items', 'main-cart-footer'].forEach(function (domId) {
      var wrapper = document.getElementById(domId);
      if (!wrapper) return;
      var sectionId = wrapper.dataset.id;
      var html = sectionId && state.sections[sectionId];
      if (!html) return;
      var source = new DOMParser().parseFromString(html, 'text/html').querySelector('.js-contents');
      var target = wrapper.querySelector('.js-contents');
      if (source && target) target.innerHTML = source.innerHTML;
    });

    var isEmpty = state.item_count === 0;
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) cartDrawerEl.classList.toggle('is-empty', isEmpty);
    var cartFooterEl = document.getElementById('main-cart-footer');
    if (cartFooterEl) cartFooterEl.classList.toggle('is-empty', isEmpty);
  }

  function removeGiftVariants(giftVariantIds) {
    var updates = {};
    giftVariantIds.forEach(function (id) {
      updates[id] = 0;
    });

    var wrapper = document.getElementById('main-cart-items');
    var footerWrapper = document.getElementById('main-cart-footer');
    var sectionIds = ['cart-drawer', 'cart-icon-bubble'];
    if (wrapper && wrapper.dataset.id) sectionIds.push(wrapper.dataset.id);
    if (footerWrapper && footerWrapper.dataset.id) sectionIds.push(footerWrapper.dataset.id);

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        applySections(state);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cbd-gift-sync', cartData: state });
        }
      })
      .catch(function (e) {
        console.error('[cbd-gift-sync] failed to remove orphaned gifts', e);
      });
  }

  function syncGifts(cart) {
    if (!cart || !cart.items) return;
    var presentVariantIds = {};
    cart.items.forEach(function (item) {
      presentVariantIds[item.variant_id || item.id] = true;
    });

    var orphanedGifts = [];
    Object.keys(GIFT_MAP).forEach(function (mainVariantId) {
      if (presentVariantIds[mainVariantId]) return; // main product still in cart
      GIFT_MAP[mainVariantId].forEach(function (giftId) {
        if (presentVariantIds[giftId]) orphanedGifts.push(giftId);
      });
    });

    if (orphanedGifts.length > 0) removeGiftVariants(orphanedGifts);
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event.source === 'cbd-gift-sync') return;
      syncGifts(event.cartData);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
